import styled, { css } from 'styled-components';
export const ListItemStyleCSS = css `
  word-break: break-word;
  margin-bottom: 8px;
`;
export default styled.li `
  ${({ order }) => order && `order: ${order};`}
  ${ListItemStyleCSS}
`;
//# sourceMappingURL=ListItemStyle.js.map